module.exports = __webpack_public_path__ + "static/shantaram-cb200a177c054363506c598fa53072e3.jpg";